import type { RouteRecordRaw } from 'vue-router'
import { Routes } from '../../Constants/Routes.ts'
import { assertThat } from '../Guards'
import NotificationListPage from '../../components/js/Components/Notification/NotificationListPage.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/notifications',
    meta: {
      guards: assertThat().authenticated(),
    },
    children: [
      {
        name: Routes.NOTIFICATIONS_VIEW,
        path: '',
        component: NotificationListPage,
      },
    ],
  },
]

export default routes
